import { useEffect } from 'react';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddCustomer from './components/AddCustomer';
import '../../styles/products.scss';

const CustomerCreate = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Créer un Client');
  }, [setTitle]);

  return (
    <div className="customer-create-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddCustomer />
        </Col>
      </Row>
    </div>
  );
};

export default CustomerCreate;